import React from 'react';
import { StudentNavbar } from '../components';

const NotFound = () => (
  <div>
    <StudentNavbar />
    <div className="w-full h-[calc(100vh-100px)] flex flex-col items-center justify-center bg-[#f0f0f0]">
      <h1 className="text-2xl font-semibold text-gray-800 mb-2">
        404 – Page Not Found
      </h1>
      <p className="text-gray-500 text-sm mb-4 text-center max-w-lg">
        We couldn’t find this page. Please check the URL or return to main page
      </p>
      <a
        href="/"
        className="text-emerald-600 text-sm font-semibold underline hover:text-emerald-700"
      >
        Back to home
      </a>
    </div>
  </div>
);

export default NotFound;